export default{
    id:null,
    categoria_id:null,
    titulo:"",
    introduccion:"",
    descripcion:"",
    imagen:"",
    tipo:"",
    fecha_publicacion:"",
    min_fecha_publicacion:"",
    max_fecha_publicacion:"",
    activo:true,
    fijo:false,
    paginate:false,
    items_to_show:10,
    order:"asc",
    order_by:"id"
}